import type { Word } from './types';

export const WORDS_EN: Omit<Word, 'level'>[] = [
{
"id": 1,
"w": "family",
"ipa": "/ˈfæməli/",
"pos": "noun",
"uz": "oila",
"ex": "My family is very big.",
"exT": "Mening oilam juda katta.",
"topic": "Oila"
},
{
"id": 2,
"w": "mother",
"ipa": "/ˈmʌðə/",
"pos": "noun",
"uz": "ona",
"ex": "My mother is a teacher.",
"exT": "Onam oʻqituvchi.",
"topic": "Oila"
},
{
"id": 3,
"w": "father",
"ipa": "/ˈfɑːðə/",
"pos": "noun",
"uz": "ota",
"ex": "His father works in a bank.",
"exT": "Uning otasi bankda ishlaydi.",
"topic": "Oila"
},
{
"id": 4,
"w": "brother",
"ipa": "/ˈbrʌðə/",
"pos": "noun",
"uz": "aka, uka",
"ex": "I have one brother.",
"exT": "Mening bitta akam bor.",
"topic": "Oila"
},
{
"id": 5,
"w": "sister",
"ipa": "/ˈsɪstə/",
"pos": "noun",
"uz": "opa, singil",
"ex": "My sister is ten years old.",
"exT": "Singlim oʻn yoshda.",
"topic": "Oila"
},
{
"id": 6,
"w": "son",
"ipa": "/sʌn/",
"pos": "noun",
"uz": "oʻgʻil",
"ex": "Their son is a doctor.",
"exT": "Ularning oʻgʻli shifokor.",
"topic": "Oila"
},
{
"id": 7,
"w": "daughter",
"ipa": "/ˈdɔːtə/",
"pos": "noun",
"uz": "qiz (farzand)",
"ex": "She has two daughters.",
"exT": "Uning ikki qizi bor.",
"topic": "Oila"
},
{
"id": 8,
"w": "child",
"ipa": "/tʃaɪld/",
"pos": "noun",
"uz": "bola",
"ex": "The child is sleeping.",
"exT": "Bola uxlayapti.",
"topic": "Oila"
},
{
"id": 9,
"w": "friend",
"ipa": "/frend/",
"pos": "noun",
"uz": "doʻst",
"ex": "Ali is my best friend.",
"exT": "Ali mening eng yaqin doʻstim.",
"topic": "Oila"
},
{
"id": 10,
"w": "baby",
"ipa": "/ˈbeɪbi/",
"pos": "noun",
"uz": "chaqaloq",
"ex": "The baby is crying.",
"exT": "Chaqaloq yigʻlayapti.",
"topic": "Oila"
},
{
"id": 11,
"w": "apple",
"ipa": "/ˈæpl/",
"pos": "noun",
"uz": "olma",
"ex": "I eat an apple every day.",
"exT": "Men har kuni olma yeyman.",
"topic": "Ovqat"
},
{
"id": 12,
"w": "bread",
"ipa": "/bred/",
"pos": "noun",
"uz": "non",
"ex": "We buy bread in the morning.",
"exT": "Biz ertalab non sotib olamiz.",
"topic": "Ovqat"
},
{
"id": 13,
"w": "water",
"ipa": "/ˈwɔːtə/",
"pos": "noun",
"uz": "suv",
"ex": "Can I have some water, please?",
"exT": "Menga ozgina suv bering, iltimos.",
"topic": "Ovqat"
},
{
"id": 14,
"w": "milk",
"ipa": "/mɪlk/",
"pos": "noun",
"uz": "sut",
"ex": "Children drink milk.",
"exT": "Bolalar sut ichadi.",
"topic": "Ovqat"
},
{
"id": 15,
"w": "tea",
"ipa": "/tiː/",
"pos": "noun",
"uz": "choy",
"ex": "We drink green tea after lunch.",
"exT": "Biz tushlikdan keyin koʻk choy ichamiz.",
"topic": "Ovqat"
},
{
"id": 16,
"w": "meat",
"ipa": "/miːt/",
"pos": "noun",
"uz": "goʻsht",
"ex": "I don't eat meat in the evening.",
"exT": "Men kechqurun goʻsht yemayman.",
"topic": "Ovqat"
},
{
"id": 17,
"w": "egg",
"ipa": "/eɡ/",
"pos": "noun",
"uz": "tuxum",
"ex": "She cooks two eggs for breakfast.",
"exT": "U nonushtaga ikkita tuxum pishiradi.",
"topic": "Ovqat"
},
{
"id": 18,
"w": "rice",
"ipa": "/raɪs/",
"pos": "noun",
"uz": "guruch",
"ex": "Plov is made with rice.",
"exT": "Palov guruchdan tayyorlanadi.",
"topic": "Ovqat"
},
{
"id": 19,
"w": "fruit",
"ipa": "/fruːt/",
"pos": "noun",
"uz": "meva",
"ex": "Fruit is good for you.",
"exT": "Meva sogʻliq uchun foydali.",
"topic": "Ovqat"
},
{
"id": 20,
"w": "breakfast",
"ipa": "/ˈbrekfəst/",
"pos": "noun",
"uz": "nonushta",
"ex": "I have breakfast at seven.",
"exT": "Men soat yettida nonushta qilaman.",
"topic": "Ovqat"
},
{
"id": 21,
"w": "dinner",
"ipa": "/ˈdɪnə/",
"pos": "noun",
"uz": "kechki ovqat",
"ex": "Dinner is ready!",
"exT": "Kechki ovqat tayyor!",
"topic": "Ovqat"
},
{
"id": 22,
"w": "hungry",
"ipa": "/ˈhʌŋɡri/",
"pos": "adjective",
"uz": "och (qorni och)",
"ex": "I'm hungry. Let's eat.",
"exT": "Qornim och. Keling, ovqatlanamiz.",
"topic": "Ovqat"
},
{
"id": 23,
"w": "house",
"ipa": "/haʊs/",
"pos": "noun",
"uz": "uy",
"ex": "Their house has a big garden.",
"exT": "Ularning uyida katta bogʻ bor.",
"topic": "Uy"
},
{
"id": 24,
"w": "room",
"ipa": "/ruːm/",
"pos": "noun",
"uz": "xona",
"ex": "My room is small but clean.",
"exT": "Xonam kichik, lekin toza.",
"topic": "Uy"
},
{
"id": 25,
"w": "door",
"ipa": "/dɔː/",
"pos": "noun",
"uz": "eshik",
"ex": "Please close the door.",
"exT": "Iltimos, eshikni yoping.",
"topic": "Uy"
},
{
"id": 26,
"w": "window",
"ipa": "/ˈwɪndəʊ/",
"pos": "noun",
"uz": "deraza",
"ex": "Open the window, it's hot.",
"exT": "Derazani oching, issiq.",
"topic": "Uy"
},
{
"id": 27,
"w": "table",
"ipa": "/ˈteɪbl/",
"pos": "noun",
"uz": "stol",
"ex": "The keys are on the table.",
"exT": "Kalitlar stol ustida.",
"topic": "Uy"
},
{
"id": 28,
"w": "chair",
"ipa": "/tʃeə/",
"pos": "noun",
"uz": "stul",
"ex": "Sit on this chair.",
"exT": "Bu stulga oʻtiring.",
"topic": "Uy"
},
{
"id": 29,
"w": "bed",
"ipa": "/bed/",
"pos": "noun",
"uz": "karavot",
"ex": "I go to bed at eleven.",
"exT": "Men soat oʻn birda yotaman.",
"topic": "Uy"
},
{
"id": 30,
"w": "kitchen",
"ipa": "/ˈkɪtʃɪn/",
"pos": "noun",
"uz": "oshxona",
"ex": "Mum is in the kitchen.",
"exT": "Oyim oshxonada.",
"topic": "Uy"
},
{
"id": 31,
"w": "key",
"ipa": "/kiː/",
"pos": "noun",
"uz": "kalit",
"ex": "I can't find my key.",
"exT": "Kalitimni topa olmayapman.",
"topic": "Uy"
},
{
"id": 32,
"w": "phone",
"ipa": "/fəʊn/",
"pos": "noun",
"uz": "telefon",
"ex": "Where is my phone?",
"exT": "Telefonim qayerda?",
"topic": "Uy"
},
{
"id": 33,
"w": "day",
"ipa": "/deɪ/",
"pos": "noun",
"uz": "kun",
"ex": "Have a nice day!",
"exT": "Kuningiz yaxshi oʻtsin!",
"topic": "Vaqt"
},
{
"id": 34,
"w": "week",
"ipa": "/wiːk/",
"pos": "noun",
"uz": "hafta",
"ex": "I work five days a week.",
"exT": "Men haftada besh kun ishlayman.",
"topic": "Vaqt"
},
{
"id": 35,
"w": "month",
"ipa": "/mʌnθ/",
"pos": "noun",
"uz": "oy",
"ex": "My birthday is next month.",
"exT": "Tugʻilgan kunim kelasi oyda.",
"topic": "Vaqt"
},
{
"id": 36,
"w": "year",
"ipa": "/jɪə/",
"pos": "noun",
"uz": "yil",
"ex": "I started English this year.",
"exT": "Men ingliz tilini shu yil boshladim.",
"topic": "Vaqt"
},
{
"id": 37,
"w": "morning",
"ipa": "/ˈmɔːnɪŋ/",
"pos": "noun",
"uz": "ertalab, tong",
"ex": "Good morning!",
"exT": "Xayrli tong!",
"topic": "Vaqt"
},
{
"id": 38,
"w": "night",
"ipa": "/naɪt/",
"pos": "noun",
"uz": "tun, kecha",
"ex": "I sleep eight hours a night.",
"exT": "Men kechasi sakkiz soat uxlayman.",
"topic": "Vaqt"
},
{
"id": 39,
"w": "today",
"ipa": "/təˈdeɪ/",
"pos": "adverb",
"uz": "bugun",
"ex": "Today is Monday.",
"exT": "Bugun dushanba.",
"topic": "Vaqt"
},
{
"id": 40,
"w": "tomorrow",
"ipa": "/təˈmɒrəʊ/",
"pos": "adverb",
"uz": "ertaga",
"ex": "See you tomorrow!",
"exT": "Ertaga koʻrishguncha!",
"topic": "Vaqt"
},
{
"id": 41,
"w": "yesterday",
"ipa": "/ˈjestədeɪ/",
"pos": "adverb",
"uz": "kecha",
"ex": "I was at home yesterday.",
"exT": "Kecha uyda edim.",
"topic": "Vaqt"
},
{
"id": 42,
"w": "time",
"ipa": "/taɪm/",
"pos": "noun",
"uz": "vaqt",
"ex": "What time is it?",
"exT": "Soat necha boʻldi?",
"topic": "Vaqt"
},
{
"id": 43,
"w": "go",
"ipa": "/ɡəʊ/",
"pos": "verb",
"uz": "bormoq",
"ex": "We go to school by bus.",
"exT": "Biz maktabga avtobusda boramiz.",
"topic": "Feʼllar"
},
{
"id": 44,
"w": "come",
"ipa": "/kʌm/",
"pos": "verb",
"uz": "kelmoq",
"ex": "Come here, please.",
"exT": "Bu yerga keling, iltimos.",
"topic": "Feʼllar"
},
{
"id": 45,
"w": "eat",
"ipa": "/iːt/",
"pos": "verb",
"uz": "yemoq",
"ex": "What do you eat for lunch?",
"exT": "Tushlikda nima yeysiz?",
"topic": "Feʼllar"
},
{
"id": 46,
"w": "drink",
"ipa": "/drɪŋk/",
"pos": "verb",
"uz": "ichmoq",
"ex": "Drink more water.",
"exT": "Koʻproq suv iching.",
"topic": "Feʼllar"
},
{
"id": 47,
"w": "sleep",
"ipa": "/sliːp/",
"pos": "verb",
"uz": "uxlamoq",
"ex": "The cat sleeps all day.",
"exT": "Mushuk kun boʻyi uxlaydi.",
"topic": "Feʼllar"
},
{
"id": 48,
"w": "read",
"ipa": "/riːd/",
"pos": "verb",
"uz": "oʻqimoq",
"ex": "I read a book every evening.",
"exT": "Men har kuni kechqurun kitob oʻqiyman.",
"topic": "Feʼllar"
},
{
"id": 49,
"w": "write",
"ipa": "/raɪt/",
"pos": "verb",
"uz": "yozmoq",
"ex": "Write your name here.",
"exT": "Ismingizni shu yerga yozing.",
"topic": "Feʼllar"
},
{
"id": 50,
"w": "speak",
"ipa": "/spiːk/",
"pos": "verb",
"uz": "gapirmoq",
"ex": "Do you speak English?",
"exT": "Siz inglizcha gapirasizmi?",
"topic": "Feʼllar"
},
{
"id": 51,
"w": "listen",
"ipa": "/ˈlɪsn/",
"pos": "verb",
"uz": "tinglamoq",
"ex": "Listen to the teacher.",
"exT": "Oʻqituvchini tinglang.",
"topic": "Feʼllar"
},
{
"id": 52,
"w": "see",
"ipa": "/siː/",
"pos": "verb",
"uz": "koʻrmoq",
"ex": "I can see the mountains.",
"exT": "Men togʻlarni koʻryapman.",
"topic": "Feʼllar"
},
{
"id": 53,
"w": "know",
"ipa": "/nəʊ/",
"pos": "verb",
"uz": "bilmoq",
"ex": "I don't know his name.",
"exT": "Men uning ismini bilmayman.",
"topic": "Feʼllar"
},
{
"id": 54,
"w": "want",
"ipa": "/wɒnt/",
"pos": "verb",
"uz": "xohlamoq",
"ex": "I want a cup of tea.",
"exT": "Men bir piyola choy xohlayman.",
"topic": "Feʼllar"
},
{
"id": 55,
"w": "like",
"ipa": "/laɪk/",
"pos": "verb",
"uz": "yoqtirmoq",
"ex": "I like football.",
"exT": "Men futbolni yoqtiraman.",
"topic": "Feʼllar"
},
{
"id": 56,
"w": "buy",
"ipa": "/baɪ/",
"pos": "verb",
"uz": "sotib olmoq",
"ex": "She buys fruit at the bazaar.",
"exT": "U bozordan meva sotib oladi.",
"topic": "Feʼllar"
},
{
"id": 57,
"w": "work",
"ipa": "/wɜːk/",
"pos": "verb",
"uz": "ishlamoq",
"ex": "My brother works in Tashkent.",
"exT": "Akam Toshkentda ishlaydi.",
"topic": "Feʼllar"
},
{
"id": 58,
"w": "play",
"ipa": "/pleɪ/",
"pos": "verb",
"uz": "oʻynamoq",
"ex": "Children play in the park.",
"exT": "Bolalar bogʻda oʻynaydi.",
"topic": "Feʼllar"
},
{
"id": 59,
"w": "open",
"ipa": "/ˈəʊpən/",
"pos": "verb",
"uz": "ochmoq",
"ex": "Open your books, please.",
"exT": "Kitoblaringizni oching, iltimos.",
"topic": "Feʼllar"
},
{
"id": 60,
"w": "help",
"ipa": "/help/",
"pos": "verb",
"uz": "yordam bermoq",
"ex": "Can you help me?",
"exT": "Menga yordam bera olasizmi?",
"topic": "Feʼllar"
},
{
"id": 61,
"w": "learn",
"ipa": "/lɜːn/",
"pos": "verb",
"uz": "oʻrganmoq",
"ex": "I learn ten new words every day.",
"exT": "Men har kuni oʻnta yangi soʻz oʻrganaman.",
"topic": "Feʼllar"
},
{
"id": 62,
"w": "give",
"ipa": "/ɡɪv/",
"pos": "verb",
"uz": "bermoq",
"ex": "Give me the pen, please.",
"exT": "Ruchkani bering, iltimos.",
"topic": "Feʼllar"
},
{
"id": 63,
"w": "take",
"ipa": "/teɪk/",
"pos": "verb",
"uz": "olmoq",
"ex": "Take an umbrella. It's raining.",
"exT": "Soyabon oling. Yomgʻir yogʻyapti.",
"topic": "Feʼllar"
},
{
"id": 64,
"w": "walk",
"ipa": "/wɔːk/",
"pos": "verb",
"uz": "yurmoq",
"ex": "I walk to work.",
"exT": "Ishga piyoda boraman.",
"topic": "Feʼllar"
},
{
"id": 65,
"w": "run",
"ipa": "/rʌn/",
"pos": "verb",
"uz": "yugurmoq",
"ex": "He runs every morning.",
"exT": "U har kuni ertalab yuguradi.",
"topic": "Feʼllar"
},
{
"id": 66,
"w": "live",
"ipa": "/lɪv/",
"pos": "verb",
"uz": "yashamoq",
"ex": "We live in Samarkand.",
"exT": "Biz Samarqandda yashaymiz.",
"topic": "Feʼllar"
},
{
"id": 67,
"w": "big",
"ipa": "/bɪɡ/",
"pos": "adjective",
"uz": "katta",
"ex": "This is a big city.",
"exT": "Bu katta shahar.",
"topic": "Sifatlar"
},
{
"id": 68,
"w": "small",
"ipa": "/smɔːl/",
"pos": "adjective",
"uz": "kichik",
"ex": "I have a small car.",
"exT": "Mening kichik mashinam bor.",
"topic": "Sifatlar"
},
{
"id": 69,
"w": "good",
"ipa": "/ɡʊd/",
"pos": "adjective",
"uz": "yaxshi",
"ex": "This is a good idea.",
"exT": "Bu yaxshi fikr.",
"topic": "Sifatlar"
},
{
"id": 70,
"w": "bad",
"ipa": "/bæd/",
"pos": "adjective",
"uz": "yomon",
"ex": "The weather is bad today.",
"exT": "Bugun ob-havo yomon.",
"topic": "Sifatlar"
},
{
"id": 71,
"w": "new",
"ipa": "/njuː/",
"pos": "adjective",
"uz": "yangi",
"ex": "I need a new phone.",
"exT": "Menga yangi telefon kerak.",
"topic": "Sifatlar"
},
{
"id": 72,
"w": "old",
"ipa": "/əʊld/",
"pos": "adjective",
"uz": "eski",
"ex": "This is an old house.",
"exT": "Bu eski uy.",
"topic": "Sifatlar"
},
{
"id": 73,
"w": "hot",
"ipa": "/hɒt/",
"pos": "adjective",
"uz": "issiq",
"ex": "It's very hot in summer.",
"exT": "Yozda juda issiq.",
"topic": "Sifatlar"
},
{
"id": 74,
"w": "cold",
"ipa": "/kəʊld/",
"pos": "adjective",
"uz": "sovuq",
"ex": "The water is cold.",
"exT": "Suv sovuq.",
"topic": "Sifatlar"
},
{
"id": 75,
"w": "happy",
"ipa": "/ˈhæpi/",
"pos": "adjective",
"uz": "baxtli",
"ex": "I'm happy to see you.",
"exT": "Sizni koʻrganimdan xursandman.",
"topic": "Sifatlar"
},
{
"id": 76,
"w": "beautiful",
"ipa": "/ˈbjuːtɪfl/",
"pos": "adjective",
"uz": "chiroyli",
"ex": "What a beautiful flower!",
"exT": "Qanday chiroyli gul!",
"topic": "Sifatlar"
},
{
"id": 77,
"w": "easy",
"ipa": "/ˈiːzi/",
"pos": "adjective",
"uz": "oson",
"ex": "This test is easy.",
"exT": "Bu test oson.",
"topic": "Sifatlar"
},
{
"id": 78,
"w": "difficult",
"ipa": "/ˈdɪfɪkəlt/",
"pos": "adjective",
"uz": "qiyin",
"ex": "Russian grammar is difficult.",
"exT": "Rus tili grammatikasi qiyin.",
"topic": "Sifatlar"
},
{
"id": 79,
"w": "fast",
"ipa": "/fɑːst/",
"pos": "adjective",
"uz": "tez",
"ex": "This train is very fast.",
"exT": "Bu poyezd juda tez.",
"topic": "Sifatlar"
},
{
"id": 80,
"w": "cheap",
"ipa": "/tʃiːp/",
"pos": "adjective",
"uz": "arzon",
"ex": "Fruit is cheap in summer.",
"exT": "Yozda meva arzon.",
"topic": "Sifatlar"
},
{
"id": 81,
"w": "expensive",
"ipa": "/ɪkˈspensɪv/",
"pos": "adjective",
"uz": "qimmat",
"ex": "This bag is too expensive.",
"exT": "Bu sumka juda qimmat.",
"topic": "Sifatlar"
},
{
"id": 82,
"w": "tired",
"ipa": "/ˈtaɪəd/",
"pos": "adjective",
"uz": "charchagan",
"ex": "I'm tired after work.",
"exT": "Ishdan keyin charchadim.",
"topic": "Sifatlar"
},
{
"id": 83,
"w": "city",
"ipa": "/ˈsɪti/",
"pos": "noun",
"uz": "shahar",
"ex": "Tashkent is a big city.",
"exT": "Toshkent katta shahar.",
"topic": "Shahar"
},
{
"id": 84,
"w": "street",
"ipa": "/striːt/",
"pos": "noun",
"uz": "koʻcha",
"ex": "I live on this street.",
"exT": "Men shu koʻchada yashayman.",
"topic": "Shahar"
},
{
"id": 85,
"w": "shop",
"ipa": "/ʃɒp/",
"pos": "noun",
"uz": "doʻkon",
"ex": "The shop opens at nine.",
"exT": "Doʻkon soat toʻqqizda ochiladi.",
"topic": "Shahar"
},
{
"id": 86,
"w": "school",
"ipa": "/skuːl/",
"pos": "noun",
"uz": "maktab",
"ex": "My son goes to school.",
"exT": "Oʻgʻlim maktabga boradi.",
"topic": "Shahar"
},
{
"id": 87,
"w": "hospital",
"ipa": "/ˈhɒspɪtl/",
"pos": "noun",
"uz": "kasalxona",
"ex": "She works at a hospital.",
"exT": "U kasalxonada ishlaydi.",
"topic": "Shahar"
},
{
"id": 88,
"w": "car",
"ipa": "/kɑː/",
"pos": "noun",
"uz": "mashina",
"ex": "Whose car is this?",
"exT": "Bu kimning mashinasi?",
"topic": "Shahar"
},
{
"id": 89,
"w": "bus",
"ipa": "/bʌs/",
"pos": "noun",
"uz": "avtobus",
"ex": "The bus is late again.",
"exT": "Avtobus yana kechikdi.",
"topic": "Shahar"
},
{
"id": 90,
"w": "money",
"ipa": "/ˈmʌni/",
"pos": "noun",
"uz": "pul",
"ex": "I don't have any money.",
"exT": "Menda pul yoʻq.",
"topic": "Shahar"
},
{
"id": 91,
"w": "park",
"ipa": "/pɑːk/",
"pos": "noun",
"uz": "bogʻ",
"ex": "Let's walk in the park.",
"exT": "Keling, bogʻda sayr qilamiz.",
"topic": "Shahar"
},
{
"id": 92,
"w": "job",
"ipa": "/dʒɒb/",
"pos": "noun",
"uz": "ish",
"ex": "I love my job.",
"exT": "Men ishimni yaxshi koʻraman.",
"topic": "Shahar"
},
{
"id": 93,
"w": "head",
"ipa": "/hed/",
"pos": "noun",
"uz": "bosh",
"ex": "My head hurts.",
"exT": "Boshim ogʻriyapti.",
"topic": "Tana"
},
{
"id": 94,
"w": "hand",
"ipa": "/hænd/",
"pos": "noun",
"uz": "qoʻl",
"ex": "Wash your hands.",
"exT": "Qoʻllaringizni yuving.",
"topic": "Tana"
},
{
"id": 95,
"w": "eye",
"ipa": "/aɪ/",
"pos": "noun",
"uz": "koʻz",
"ex": "She has blue eyes.",
"exT": "Uning koʻzlari koʻk.",
"topic": "Tana"
},
{
"id": 96,
"w": "red",
"ipa": "/red/",
"pos": "adjective",
"uz": "qizil",
"ex": "I have a red bag.",
"exT": "Mening qizil sumkam bor.",
"topic": "Ranglar"
},
{
"id": 97,
"w": "white",
"ipa": "/waɪt/",
"pos": "adjective",
"uz": "oq",
"ex": "Snow is white.",
"exT": "Qor oq.",
"topic": "Ranglar"
},
{
"id": 98,
"w": "book",
"ipa": "/bʊk/",
"pos": "noun",
"uz": "kitob",
"ex": "This book is interesting.",
"exT": "Bu kitob qiziqarli.",
"topic": "Taʼlim"
},
{
"id": 99,
"w": "teacher",
"ipa": "/ˈtiːtʃə/",
"pos": "noun",
"uz": "oʻqituvchi",
"ex": "Our teacher is very kind.",
"exT": "Oʻqituvchimiz juda mehribon.",
"topic": "Taʼlim"
},
{
"id": 100,
"w": "word",
"ipa": "/wɜːd/",
"pos": "noun",
"uz": "soʻz",
"ex": "What does this word mean?",
"exT": "Bu soʻz nimani anglatadi?",
"topic": "Taʼlim"
}
];
